export type StatusAuditoria = 'ERRO' | 'ALERTA' | 'AVISO' | 'CONCILIADO';
export type TributoAuditoria = 'TODOS' | 'IRPJ' | 'CSLL' | 'PIS' | 'COFINS' | 'EXTRATO_BANCARIO' | 'SALDOS_BANCARIOS' | 'DEPRECIACAO_AMORTIZACAO' | 'AUDITORIA_CAIXA' | 'AUDITORIA_FINANCEIRA' | 'AUDITORIA_ZERAMENTO_13' | 'AUDITORIA_BAIXA_PATRIMONIAL' | 'AUDITORIA_ADIANTAMENTO' | 'AUDITORIA_ADIANTAMENTO_CLIENTES' | 'AUDITORIA_DESPESAS_ANTECIPADAS' | 'AUDITORIA_AJUSTE_EXERCICIOS_ANTERIORES' | 'AUDITORIA_CONTAS_PAGAR_RECEBER' | 'AUDITORIA_FORNECEDORES_CONCILIACAO' | 'AUDITORIA_RECEITAS_DIFERIDAS' | 'AUDITORIA_INTEGRIDADE_LANCAMENTOS' | 'AUDITORIA_ADIANTAMENTO_SOCIOS' | 'AUDITORIA_BENEFICIOS_INDIRETOS' | 'AUDITORIA_RASTREABILIDADE_BANCARIA' | 'AUDITORIA_ARREDONDAMENTOS_AJUSTES' | 'AUDITORIA_ADIANTAMENTO_FUNCIONARIOS' | 'AUDITORIA_ADIANTAMENTO_SALARIO' | 'AUDITORIA_ANOMALIA_TARIFA_BANCARIA' | 'AUDITORIA_CONTA_TRANSITORIA' | 'AUDITORIA_ADIANTAMENTO_VIAGEM' | 'AUDITORIA_CLASSIFICACAO_RECEITA' | 'AUDITORIA_PROVISAO_PIS_COFINS' | 'AUDITORIA_PROVISAO_ISS' | 'AUDITORIA_PROVISAO_ICMS' | 'AUDITORIA_DUPLICIDADE_PAGAMENTOS' | 'AUDITORIA_ROTATIVIDADE_PROVISOES' | 'AUDITORIA_PDD_ANALITICA' | 'AUDITORIA_PEJOTIZACAO' | 'AUDITORIA_LANCAMENTO_MANUAL' | 'AUDITORIA_LANCAMENTO_ESTORNO' | 'AUDITORIA_LANCAMENTO_DIA_NAO_UTIL' | 'AUDITORIA_DESPESA_ANALITICA_RELEVANTE' | 'AUDITORIA_LANCAMENTO_CORRETIVO' | 'AUDITORIA_SERVICOS_TERCEIROS_PF' | 'AUDITORIA_SOCIETARIA' | 'AUDITORIA_QUALIDADE_HISTORICOS' | 'AUDITORIA_TRANSFER_PRICING' | 'AUDITORIA_CAMBIAL' | 'AUDITORIA_ROUND_TRIPPING' | 'AUDITORIA_CASH_RICH' | 'AUDITORIA_MUTACAO_VOLATIL' | 'AUDITORIA_CREDITO_ESTAGNADO' | 'AUDITORIA_PROVISAO_ESPELHO' | 'AUDITORIA_CORRELACAO_RECEITA' | 'AUDITORIA_VALOR_REDONDO' | 'AUDITORIA_OUTRAS_DESPESAS' | 'AUDITORIA_ESTOQUE_SEM_MOVIMENTO' | 'AUDITORIA_SPLIT_DESPESAS' | 'AUDITORIA_CAIXA_FORNECEDORES' | 'AUDITORIA_CIRCULARIDADE_TRANSITORIA' | 'AUDITORIA_CORRELACAO_FISCAL' | 'AUDITORIA_PL_INTEGRIDADE' | 'AUDITORIA_PAYROLL_DRIFT' | 'AUDITORIA_ASSET_RECOVERY' | 'AUDITORIA_SIM_CAPITAL';

// Trial 72h (Camada 2): a seleção individual de tributo no dropdown fica restrita a este
// subconjunto — módulos liberados por decisão de produto (não técnica). O trial mostra 100% dos
// dados (ver Ainumera.Api/Controllers/Auditoria/AuditoriaControllerBase.cs); a restrição real é só
// QUAIS módulos podem ser abertos individualmente. Os demais tributos continuam somando no resumo
// agregado da aba TODOS, só não ficam disponíveis para abrir o detalhe individual durante o trial.
export const TRIBUTOS_PERMITIDOS_TRIAL: TributoAuditoria[] = [
  'AUDITORIA_INTEGRIDADE_LANCAMENTOS',
  'AUDITORIA_FORNECEDORES_CONCILIACAO',
  'DEPRECIACAO_AMORTIZACAO',
  'AUDITORIA_PROVISAO_ISS',
  'AUDITORIA_CAIXA_FORNECEDORES',
  'AUDITORIA_SERVICOS_TERCEIROS_PF',
  'AUDITORIA_FINANCEIRA',
  'AUDITORIA_ROTATIVIDADE_PROVISOES',
  'AUDITORIA_BENEFICIOS_INDIRETOS',
  'AUDITORIA_SOCIETARIA',
  'AUDITORIA_ARREDONDAMENTOS_AJUSTES',
  'AUDITORIA_SIM_CAPITAL',
  // Adicionados a pedido do usuário: Bancos, Estoque, Clientes.
  'SALDOS_BANCARIOS',
  'AUDITORIA_ESTOQUE_SEM_MOVIMENTO',
  'AUDITORIA_ADIANTAMENTO_CLIENTES',
  // Adicionados a pedido do usuário (2ª rodada): "Bancos" também cobre Caixa/Espécie/Benefício
  // Indireto (bancário em sentido amplo — o usuário confirmou que era essa a lacuna, distinta de
  // Saldos Bancários, que já estava liberado); "Empréstimo" corresponde a Adiantamentos e
  // Empréstimos a Funcionários (não existe um módulo dedicado só de "empréstimo" no sistema);
  // Qualidade de Históricos foi pedido junto do bloco de "Clientes" (identificação de participante
  // no histórico do lançamento).
  'AUDITORIA_CAIXA',
  'AUDITORIA_ADIANTAMENTO_FUNCIONARIOS',
  'AUDITORIA_QUALIDADE_HISTORICOS',
];

export interface IEmpresaAuditoria {
  id: number;
  clienteId: number;
  nomeFantasia: string;
  razaoSocial?: string;
  cnpj: string;
}

export interface IPeriodoAuditoria {
  esteiraId: number;
  empresaId: number;
  periodo: string;
  descricao: string;
  periodoInicio: string;
  periodoFim: string;
}

export interface ICotaAuditoria {
  numeroCota: number;
  dataVencimento: string;
  valorPrincipal: number;
  valorJurosCalculado: number;
  totalCota: number;
  jurosValidadoDre: boolean;
}

export interface ITrimestreAuditoria {
  periodo: string;
  dataInicio: string;
  dataFim: string;
  receitaBruta: number;
  devolucoes: number;
  faturamentoLiquido: number;
  provisaoPassivo: number;
  confrontoFechamento: number;
  compensacaoSaldo?: number;
  retencaoAtivo: number;
  baixaPosFechamento: number;
  deixouDeCompensar: number;
  potencialCompensacaoNaoAproveitado?: number;
  pagoAMais: number;
  residualAberto: number;
  penalidadePrevisivel: number;
  status: StatusAuditoria;
  mensagem: string;
  legendaStatus?: string;
}

export interface ILancamentoAuditoria {
  id: number;
  tributo: 'IRPJ' | 'CSLL' | 'PIS' | 'COFINS';
  trimestre: string;
  classificacao: string;
  contaContabil: string;
  contaReferencial: string;
  descricaoConta: string;
  dataLancamento: string;
  historico: string;
  tipoLancamento: string;
  valor: number;
}

export interface IResumoEmpresaAuditoria {
  empresaId: number;
  nomeFantasia: string;
  cnpj: string;
  tributo: 'IRPJ' | 'CSLL' | 'PIS' | 'COFINS';
  faturamentoFiscal: number;
  provisaoContabil: number;
  confrontoEfetuado: number;
  compensacaoSaldo?: number;
  impactoFinanceiroResidual: number;
  potencialCompensacaoNaoAproveitado?: number;
  status: StatusAuditoria;
}

export interface IAuditoriaTributo {
  tributo: 'IRPJ' | 'CSLL' | 'PIS' | 'COFINS';
  status: StatusAuditoria;
  mensagemDirecionamento: string;
  legendaStatus?: string;
  faturamentoConciliado: boolean;
  faturamentoFiscal: number;
  desvioFaturamento: number;
  saldoProvisaoRealPassivo: number;
  confrontoRealizadoNoFechamento: number;
  compensacaoSaldo?: number;
  dinheiroDeixouDeCompensar: number;
  potencialCompensacaoNaoAproveitado?: number;
  dinheiroPagouAMais: number;
  valorResidualAberto: number;
  jurosLancadosNaDRE: number;
  valorPagoTotal: number;
  totalErros: number;
  totalAvisos: number;
  totalAlertas: number;
  legislacaoContabil: string;
  legislacaoFiscal: string;
  sugestaoParcelamentoCotas: ICotaAuditoria[];
  trimestres: ITrimestreAuditoria[];
  lancamentos: ILancamentoAuditoria[];
}

export interface IAuditoriaResultado {
  cards: IAuditoriaTributo[];
  empresas: IResumoEmpresaAuditoria[];
}
